<div class="initiative-standalone"
  [ngClass]="{'vertical'  : vertical(), 'fh' : settingsManager.settings.theme == 'fh', 'modern' : settingsManager.settings.theme == 'modern'}"
  ghs-keyboard-shortcuts>
  <ghs-header #header [standalone]="true" [connection]="true"></ghs-header>

  <div class="scroll-container">
    @if (!!character) {
    <div class="dialog">
      <div class="dialog-container initiative-dialog">
        <div class="title">
          <span class="character" (click)="openCharacterSheet()">
            <img class="icon" [src]="character.iconUrl" />
            {{ gameManager.characterManager.characterName(character)}}
            @if (character.title) {
            <span>&nbsp;(<span
                [ghs-label]="'data.character.' + character.edition + '.' + character.name"></span>)</span>
            }
          </span>
          <div class="initiative"
            [ngClass]="{'error' : statusCode != 200 && statusCode != 403, 'warn': statusCode == 403}">
            @if (character.initiative && (character.initiativeVisible || gameManager.game.state == 'next')) {
            <span class="value">
              @if (character.initiative < 10) { <span>0</span>
            }
            <span>{{character.initiative}}</span>
            </span>
            }
            @if (character.initiative && !character.initiativeVisible && gameManager.game.state != 'next') {
            <span class="value">
              ??
            </span>
            }
            @if (!character.initiative) {
            <span class="value">
              --
            </span>
            }
            @if (character.initiativeVisible && character.initiative == 99 && character.longRest) {
            <img class="ghs-svg" src="./assets/images/long-rest.svg">
            }
          </div>
          @if (!vertical()) {
          <span class="spacer"></span>
          <span class="long-rest-button" [ngClass]="{'active' : longRest}" (click)="setLongRest()">
            <img class="ghs-svg" src="./assets/images/long-rest.svg"> <span
              [ghs-label]="'game.figure.longRest' + (longRest ? 'Off' : '')"></span>
          </span>
          }
        </div>
        <div class="number-container">
          <span></span>
          <span class="value">{{value}}
            @if (longRest) {
            <img class="ghs-svg" src="./assets/images/long-rest.svg">
            }</span>
          <span></span>
          @for (number of [1,2,3,4,5,6,7,8,9]; track number) {
          <span class="number-button" (click)="pickNumber(number)">
            <span class="number">{{number}}</span>
          </span>
          }
          <span class="number-button" (click)="value = '__'">
            <span class="number">*</span>
          </span>
          <span class="number-button" (click)="pickNumber(0)">
            <span class="number">0</span>
          </span>
          <span class="number-button" (click)="setCurrentValue()">
            <span class="number">#</span>
          </span>
        </div>
        @if (vertical()) {
        <span class="long-rest-button" [ngClass]="{'active' : longRest}" (click)="setLongRest()">
          <img class="ghs-svg" src="./assets/images/long-rest.svg"> <span
            [ghs-label]="'game.figure.longRest' + (longRest ? 'Off' : '')"></span>
        </span>
        }
      </div>
    </div>
    }

    <div class="characters">
      @for (c of characters | trackUUID; track c._trackUUID; let i = $index) {
      <span class="character" [ngClass]="{'active': character == c}" (click)="selectCharacter(c)"><img
          [src]="c.iconUrl"></span>
      }
      @if (!!character) {
      <label>
        <input type="checkbox" [checked]="settingsManager.settings.standaloneInitiativeAutomatic"
          (change)="settingsManager.toggle('standaloneInitiativeAutomatic')">
        <span [ghs-label]="'Automatic'"></span>
      </label>
      }
    </div>
  </div>
</div>